import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import s from './SignupPage.module.css';

export default function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    if (password.length < 10) {
      setError('Password must be at least 10 characters.');
      return;
    }

    setLoading(true);
    try {
      await signup(email, password);
      navigate('/onboard', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Signup failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={s.page}>
      <div className={s.card}>
        <div className={s.logo}>DMARCopolo</div>
        <h1 className={s.heading}>Create your account</h1>

        <form className={s.form} onSubmit={handleSubmit}>
          {error && <div className={s.error}>{error}</div>}

          <div className={s.field}>
            <label htmlFor="email" className={s.label}>Email</label>
            <input
              id="email"
              type="email"
              className={s.input}
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className={s.field}>
            <label htmlFor="password" className={s.label}>Password</label>
            <input
              id="password"
              type="password"
              className={s.input}
              placeholder="Choose a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={10}
            />
            <span className={s.hint}>Minimum 10 characters</span>
          </div>

          <button type="submit" className={s.btnSubmit} disabled={loading}>
            {loading ? 'Creating account\u2026' : 'Create Account'}
          </button>
        </form>

        <p className={s.footer}>
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
